const BACKEND_URL = "https://admin.smart-team.de:4000/"
//const BACKEND_URL = "http://localhost:4000/"
//const BACKEND_URL = "http://localhost:30001/"

export {BACKEND_URL}
